import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpencvComponent } from './simple-icons-opencv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpencvComponent ],
    exports:      [ SimpleIconsOpencvComponent ],
    bootstrap:    []
})
export class SimpleIconsOpencvModule {}
